import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    accountStatusCheck as accountStatusCheckAction,
    clearAuthNotification as clearAuthNotificationAction,
    onSkipSocialLinks,
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    trackComunityGuidelinesClick as trackComunityGuidelinesClickAction,
    trackGetStartedClick as trackGetStartedClickAction,
    trackPrivacyPolicyClick as trackPrivacyPolicyClickAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    trackTermsOfServiceClick as trackTermsOfServiceClickAction,
} from '../../actions/auth';

import {
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
} from '../../actions/gaTracking';

import LookupPage from './LookupPage';

const _mapStateToProps = ({ authentication, form }) => ({
    authNotificationOptions: authentication.authNotificationOptions,
    disableRecaptcha3: authentication.disableRecaptcha3,
    form,
    fp: authentication.fp,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    socialAuthenticationData: authentication.socialAuthenticationData,
    socialSSOSettings: authentication.socialSSOSettings,
});

const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onAccountStatusCheck: accountStatusCheckAction,
    onComunityGuidelinesClick: trackComunityGuidelinesClickAction,
    onGetStartedClick: trackGetStartedClickAction,
    onSkipSocialLinks,
    onPrivacyPolicyClick: trackPrivacyPolicyClickAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onTermsOfServiceClick: trackTermsOfServiceClickAction,
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LookupPage),
);
